import React, {Component} from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';

import Reservation from "./frontoffice/Reservation";

import Home from "./Home";
import Authenticate from "./Authenticate";
import LayoutBack from "./backoffice/Layout";
import Reservations from "./backoffice/Reservations";
import Calendriers from "./backoffice/Calendriers";
import Croisiere from "./backoffice/Croisiere";
import Extras from "./backoffice/Extras";
import Flotte from "./backoffice/Flotte";
import Bateau from "./backoffice/Bateau";
import Maintenances from "./backoffice/Maintenances";
import Maintenance from "./backoffice/Maintenance";
import Anomalies from "./backoffice/Anomalies";
import Anomalie from "./backoffice/Anomalie";
import Observations from "./backoffice/Observations";
import Observation from "./backoffice/Observation";
import Utilisateurs from "./backoffice/Utilisateurs";
import Utilisateur from "./backoffice/Utilisateur";
import Labels from "./backoffice/Labels";
import Settings from "./backoffice/Settings";
import MailsTemplates from "./backoffice/MailsTemplates";
import Villes from "./backoffice/Villes";
import Ville from "./backoffice/Ville";
// import CheckCapitaine from "./CheckCapitaine";
// import withCapitaineGuard from "./CheckCapitaine";
import checkCapitaine from "./CheckCapitaine";

const ThemeFront = React.lazy(() => import('./frontoffice/Theme'));
const ThemeBack = React.lazy(() => import('./backoffice/Theme'));

class AppRouter extends Component {
    render() {
        return (

            <BrowserRouter>
                <Switch>
                    <Route path="/admin" exact component={Home}/>
                    <React.Suspense fallback={() => null}>
                        {!window.location.pathname.includes("admin") &&
                            <React.Fragment>
                                <ThemeFront/>
                                <Route path="/:villeId?" component={Reservation}/>
                            </React.Fragment>
                        }
                        {window.location.pathname.includes("admin") &&
                            <React.Fragment>
                                <ThemeBack/>
                                <Authenticate>
                                    <LayoutBack>
                                        <Route path="/admin/reservations" exact component={Reservations}/>
                                        <Route path="/admin/calendriers/:villeId?/:croisiereId?/:croisiereDate?"
                                               component={Calendriers}/>
                                        <Route path="/admin/extras/:villeId?/:croisiereId?/:croisiereDate?" exact
                                               component={Extras}/>
                                        <Route
                                            path="/admin/croisiere/:croisiereId?/:croisiereTypeId?/:croisiereTypeDuree?/:croisiereBateauId?/:croisiereBateauName?/:croisiereDate?/:selectedCroisireToCopyId?/:croisiereCapitaineId?/:croisiereCapitaineName?"
                                            component={Croisiere}/>
                                        <Route path="/admin/flotte" exact component={checkCapitaine(Flotte)}/>
                                        <Route path="/admin/maintenances" exact component={checkCapitaine(Maintenances)}/>
                                        <Route path="/admin/anomalies" exact component={checkCapitaine(Anomalies)}/>
                                        <Route path="/admin/observations" exact component={checkCapitaine(Observations)}/>
                                        <Route path="/admin/utilisateurs" exact component={checkCapitaine(Utilisateurs)}/>

                                        <Route path="/admin/bateau/:bateauId?" exact component={checkCapitaine(Bateau)}/>
                                        <Route path="/admin/maintenance/:maintenanceId?" exact
                                               component={checkCapitaine(Maintenance)}/>
                                        <Route path="/admin/anomalie/:anomalieId?" exact component={checkCapitaine(Anomalie)}/>
                                        <Route path="/admin/observation/:observationId?" exact
                                               component={checkCapitaine(Observation)}/>
                                        <Route path="/admin/utilisateur/:rootId?" exact component={checkCapitaine(Utilisateur)}/>

                                        <Route path="/admin/croisiereTypes" exact
                                               component={() => <Settings screenId={107} workflowId={7}
                                                                          path={'/admin/croisiereTypes'}/>}/>
                                        <Route path="/admin/eventTypes" exact
                                               component={() => <Settings screenId={108} workflowId={8}
                                                                          path={'/admin/eventTypes'}/>}/>
                                        <Route path="/admin/options" exact
                                               component={() => <Settings screenId={109} workflowId={9}
                                                                          path={'/admin/options'}/>}/>
                                        <Route path="/admin/ramassages" exact
                                               component={() => <Settings screenId={110} workflowId={10}
                                                                          path={'/admin/ramassages'}/>}/>
                                        <Route path="/admin/anomalieMaintenanceTypes" exact
                                               component={() => <Settings screenId={111} workflowId={11}
                                                                          path={'/admin/anomalieMaintenanceTypes'}/>}/>

                                        <Route path="/admin/labels" exact component={checkCapitaine(Labels)}/>

                                        <Route path="/admin/mailsTemplates" exact component={checkCapitaine(MailsTemplates)}/>
                                        <Route path="/admin/Villes" exact component={checkCapitaine(Villes)}/>
                                        <Route path="/admin/Ville/:rootId?" exact component={checkCapitaine(Ville)}/>
                                    </LayoutBack>
                                </Authenticate>
                            </React.Fragment>
                        }
                    </React.Suspense>
                </Switch>
            </BrowserRouter>
        );
    }
}

export default AppRouter;
